import "@/App.css";
import "@/i18n";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, ProtectedRoute, AdminOnlyRoute, useAuth } from "@/lib/auth";
import { PublicLayout, AdminLayout } from "@/components/Layout";
import PublicHome from "@/pages/PublicHome";
import PublicGames from "@/pages/PublicGames";
import PublicGameDetail from "@/pages/PublicGameDetail";
import PublicTeams from "@/pages/PublicTeams";
import PublicTeamDetail from "@/pages/PublicTeamDetail";
import PublicPlayers from "@/pages/PublicPlayers";
import PublicPlayerDetail from "@/pages/PublicPlayerDetail";
import PublicLeaders from "@/pages/PublicLeaders";
import TournamentPortal from "@/pages/TournamentPortal";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminTournaments from "@/pages/AdminTournaments";
import AdminTeams from "@/pages/AdminTeams";
import AdminPlayers from "@/pages/AdminPlayers";
import AdminVenues from "@/pages/AdminVenues";
import AdminGames from "@/pages/AdminGames";
import AdminUsers from "@/pages/AdminUsers";
import AdminSettings from "@/pages/AdminSettings";
import LiveOperator from "@/pages/LiveOperator";
import Scoreboard from "@/pages/Scoreboard";

function DashboardOrRedirect() {
  const { user } = useAuth();
  if (user && user !== false && user.role !== "admin") {
    return <Navigate to="/admin/games" replace />;
  }
  return <AdminDashboard />;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster theme="dark" position="top-right" richColors />
          <Routes>
            {/* Public portal */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<PublicHome />} />
              <Route path="/games" element={<PublicGames />} />
              <Route path="/games/:id" element={<PublicGameDetail />} />
              <Route path="/teams" element={<PublicTeams />} />
              <Route path="/teams/:id" element={<PublicTeamDetail />} />
              <Route path="/players" element={<PublicPlayers />} />
              <Route path="/players/:id" element={<PublicPlayerDetail />} />
              <Route path="/leaders" element={<PublicLeaders />} />
              <Route path="/t/:slug" element={<TournamentPortal />} />
            </Route>

            <Route path="/login" element={<Login />} />

            {/* Public scoreboard overlay for TV/projection (no auth) */}
            <Route path="/scoreboard/:gameId" element={<Scoreboard />} />

            {/* Admin (protected) */}
            <Route element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route path="/admin" element={<DashboardOrRedirect />} />
              <Route path="/admin/tournaments" element={<AdminOnlyRoute><AdminTournaments /></AdminOnlyRoute>} />
              <Route path="/admin/teams" element={<AdminOnlyRoute><AdminTeams /></AdminOnlyRoute>} />
              <Route path="/admin/players" element={<AdminOnlyRoute><AdminPlayers /></AdminOnlyRoute>} />
              <Route path="/admin/venues" element={<AdminOnlyRoute><AdminVenues /></AdminOnlyRoute>} />
              <Route path="/admin/games" element={<AdminGames />} />
              <Route path="/admin/users" element={<AdminOnlyRoute><AdminUsers /></AdminOnlyRoute>} />
              <Route path="/admin/settings" element={<AdminOnlyRoute><AdminSettings /></AdminOnlyRoute>} />
            </Route>

            {/* Live operator full-screen (protected, no admin layout) */}
            <Route
              path="/operator/:gameId"
              element={
                <ProtectedRoute>
                  <LiveOperator />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
